import React, { FC } from 'react';
import styles from './Dropdown-style.scss';

const DropdownBody: FC = ({ children }) => {
    return <div className={styles.body}>{children}</div>;
};

export default DropdownBody;
